var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgUsdt(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M24 12C24 18.6274 18.6274 24 12 24C5.37258 24 0 18.6274 0 12C0 5.37258 5.37258 0 12 0C18.6274 0 24 5.37258 24 12ZM13.4415 10.3448V8.57025H17.502V5.86425H6.44623V8.57025H10.5067V10.344C7.20673 10.4955 4.72498 11.1495 4.72498 11.9325C4.72498 12.7155 7.20673 13.3688 10.5067 13.521V19.2075H13.4415V13.5195C16.7362 13.368 19.212 12.7148 19.212 11.9325C19.212 11.1503 16.7362 10.497 13.4415 10.3448ZM13.4415 13.0373V13.0357C13.359 13.0417 12.9337 13.0673 11.985 13.0673C11.2275 13.0673 10.6942 13.0448 10.5067 13.0357V13.038C7.59073 12.9097 5.41423 12.402 5.41423 11.7945C5.41423 11.1877 7.59073 10.68 10.5067 10.5495V12.5325C10.6972 12.546 11.2432 12.5782 11.9977 12.5782C12.903 12.5782 13.3567 12.5408 13.4415 12.5332V10.551C16.3515 10.6807 18.5227 11.1885 18.5227 11.7945C18.5227 12.402 16.3515 12.9083 13.4415 13.0373Z",
    fill: "#646464"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgUsdt);
export default __webpack_public_path__ + "static/media/usdt.486e5c1aa47203ae3dfb1c6a8edc6a7e.svg";
export { ForwardRef as ReactComponent };